import {WalletContext} from '#/contexts/wallet-provider';
import environment from '#/environment/environment';
import {useInvalidateQueries} from '#/hooks/query/base/use-invalidate-queries';
import {DefaultChildren} from '#/utils/utils';
import {Dispatch, FunctionComponent, SetStateAction, createContext, useContext, useEffect, useState} from 'react';
import {ERC20Mock__factory} from 'shareland-common';

export interface ImportWalletTransactionsContextValue {
  setWatch: Dispatch<SetStateAction<boolean>>;
}

export const ImportWalletTransactionsContext = createContext<ImportWalletTransactionsContextValue>(
  {} as ImportWalletTransactionsContextValue,
);

export const ImportWalletTransactionsProvider: FunctionComponent<DefaultChildren> = ({children}) => {
  const {
    accountResult: {address, isConnected},
    publicClient,
  } = useContext(WalletContext);

  const invalidateQueries = useInvalidateQueries();
  const [watch, setWatch] = useState(false);

  useEffect(() => {
    if (!watch || !address || !isConnected || !publicClient) return;

    const unwatchStable = publicClient.watchContractEvent({
      abi: ERC20Mock__factory.abi,
      eventName: 'Transfer',
      address: environment.stableTokenAddress,
      args: {
        to: address,
      },
      onLogs: () => {
        invalidateQueries.useStableTokenBalance();
      },
    });

    return () => {
      unwatchStable();
    };
  }, [watch, address, isConnected, publicClient, invalidateQueries]);

  return (
    <ImportWalletTransactionsContext.Provider value={{setWatch}}>{children}</ImportWalletTransactionsContext.Provider>
  );
};
